<mat-toolbar class="fullscreen-toolbar" color="primary" mat-dialog-title>
  <mat-toolbar-row><h3>New Follow-On</h3></mat-toolbar-row>
</mat-toolbar>

@if (!visitCreationDone) {
  <mat-dialog-content class="fullscreen-dialog">
    <p>
      To create a new follow on, select a visit type and enter a duration below.
    </p>
    <div>
      <mat-form-field>
        <mat-label>{{ 'scheduler.search.job.visit.type' | translate }}</mat-label>
        <mat-select [formControl]="VisitTypeList">
          @for (visitType of visitTypeStore.entities | async; track visitType) {
            <mat-option [value]="visitType">{{
              visitType.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button (click)="chooseVisitType()" color="primary" mat-flat-button type="button">Search</button>
    </div>
    <mat-form-field>
      <input [formControl]="durationField" [value]="" autocomplete="off" matInput
        placeholder="{{'scheduler.search.job.visit.duration' | translate}}" type="number" min="0" />
      </mat-form-field>
    </mat-dialog-content>
  }

  @if (visitCreationDone) {
    <mat-dialog-content class="fullscreen-dialog">
      <div class="success-content">
        <p>Follow-On successfully added.</p>
        <button mat-flat-button color="primary" (click)="bookNewVisit()" mat-dialog-close>Book
        Appointment</button>
        <button mat-flat-button mat-dialog-close>Skip</button>
      </div>
    </mat-dialog-content>
  }

  @if (!visitCreationDone) {
    <mat-dialog-actions class="dialog-actions">
      <button (click)="dialogRef.close()" color="warn" mat-flat-button type="button">{{ 'scheduler.general.cancel' |
        translate }}
      </button>
      <span class="spacer"></span>
      <button (click)="addVisit()" color="primary" mat-flat-button>{{ 'scheduler.search.job.visit.add' | translate }}
      </button>
    </mat-dialog-actions>
  }
